import { FC } from 'react'
import { AvatarProps } from 'antd/es/avatar'
import { useAppSelector } from '../../store/hooks'
import { Cluster as ClusterModel } from '../../models/Cluster'
import { Flex, Space, Typography } from 'antd'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Localizable } from '../localizable/Localizable'
import { selectClusterById } from '../../store/ClusterReducer'

const { Text } = Typography

type Props = SBModelComponent<ClusterModel> & {
  size?: AvatarProps['size']
}

const ClusterAvatar: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectClusterById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Space>
      <Flex gap={10}>
        <Localizable.Render
          item={item}
          render={(localizedItem, lang) => (
            <Text>
              {lang.flag} {localizedItem.title}
            </Text>
          )}
        />
      </Flex>
    </Space>
  )
}

type ClusterAvatarType = { Avatar: typeof ClusterAvatar }

export { ClusterAvatar, type ClusterAvatarType }
